import { $, $$ } from './utils'

export const sortCasinos = (button) => {
  const sortBy = button.dataset.sort
  const arrowSpan = $('.arrow', button)

  const sortWrapper = button.closest('.listing-tools')
  const sortId = sortWrapper.dataset.id

  // If it's sorting by a new key, reset stuff
  if (sortWrapper.dataset.sorted !== sortBy) {
    sortWrapper.dataset.sort = 'desc'
    sortWrapper.dataset.sorted = sortBy
    arrowSpan.innerText = ''
  }

  // ASC or DESC. (set `asc` for `default`, we need the default to be 1,2,3,4 ...)
  const sortDir = sortBy === 'default' ? 'asc' : sortWrapper.dataset.sort
  sortWrapper.dataset.sort = sortDir === 'desc' ? 'asc' : 'desc'

  // Adjust arrows ↑↓
  arrowSpan.innerText = arrowSpan.innerText === '↓' ? '↑' : '↓'

  // Highlight selected key.
  $$('.spinoko-listing--sort-button', sortWrapper).forEach((btn) => btn.classList.remove('sorted'))
  button.classList.add('sorted')

  const alphaSort = (a, b) => {
    const get = (item) => item.dataset[sortBy].toLowerCase()
    return sortDir === 'desc' ? get(b).localeCompare(get(a)) : get(a).localeCompare(get(b))
  }
  const numSort = (a, b) => {
    const get = (item) => parseFloat(item.dataset[sortBy])
    return sortDir === 'desc' ? get(b) - get(a) : get(a) - get(b)
  }
  const sortItems = (a, b) => (sortBy === 'alpha' ? alphaSort(a, b) : numSort(a, b))

  const ul = $(`[data-listing-id="${sortId}"]`)
  Array.from(ul.children)
    .filter((i) => !i.classList.contains('items-unavailable'))
    .sort((a, b) => sortItems(a, b))
    .forEach((item) => ul.appendChild(item))
}
